import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _assignRequest = {};
var _assignResponse = {};
var _listMembersRequest = {};
var _listMembersResponse = {};
var _listPermissionLevelsRequest = {};
var _listPermissionLevelsResponse = {};
var _listRolesRequest = {};
var _listRolesResponse = {};
var _removeRequest = {};
var _removeResponse = {};
var _requestAccessRequest = {};
var _requestAccessResponse = {};
var _setPermissionsLevelRequest = {};
var _setPermissionsLevelResponse = {};
var _updateAccessFlagsRequest = {};
var _updateAccessFlagsResponse = {};
function resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl(opts) {
    var domainToMappings = {
        'apps._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '',
            },
        ],
        'filesharing._base_domain_': [
            {
                srcPath: '',
                destPath: '',
            },
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
            {
                srcPath: '/api/v1',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'bo._base_domain_': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/file-sharing-server',
                destPath: '/management-api',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/file-sharing-server/_api',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        _: [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
        'editor.wixapps.net': [
            {
                srcPath: '/api/v1/file-sharing',
                destPath: '/api/v1/file-sharing',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Updates access permission flags for a given library item */
export function updateAccessFlags(payload) {
    var _a = serializer(_updateAccessFlagsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateAccessFlagsResponse, {}).fromJSON;
    function __updateAccessFlags(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.UpdateAccessFlags',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/file-sharing/v1/permissions/update-access-flags',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateAccessFlags.fromReq = fromReq;
    __updateAccessFlags.__isAmbassador = true;
    return __updateAccessFlags;
}
/** Removes permission from given roles */
export function remove(payload) {
    var _a = serializer(_removeRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_removeResponse, {}).fromJSON;
    function __remove(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.Remove',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/permissions/remove',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __remove.fromReq = fromReq;
    __remove.__isAmbassador = true;
    return __remove;
}
/** Adds permissions for roles */
export function assign(payload) {
    var _a = serializer(_assignRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_assignResponse, {}).fromJSON;
    function __assign(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.Assign',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/permissions/assign',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __assign.fromReq = fromReq;
    __assign.__isAmbassador = true;
    return __assign;
}
/** Set permissions levels for a given library item */
export function setPermissionsLevel(payload) {
    var _a = serializer(_setPermissionsLevelRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setPermissionsLevelResponse, {}).fromJSON;
    function __setPermissionsLevel(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.SetPermissionsLevel',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/permissions/level',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setPermissionsLevel.fromReq = fromReq;
    __setPermissionsLevel.__isAmbassador = true;
    return __setPermissionsLevel;
}
/** Given the permission name lists all roles that have this permission assigned */
export function listRoles(payload) {
    var _a = serializer(_listRolesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listRolesResponse, {}).fromJSON;
    function __listRoles(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.ListRoles',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/roles',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
            fallback: [
                {
                    method: 'GET',
                    url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                        protoPath: '/api/v1/file-sharing/roles',
                        data: serializedData,
                        host: host,
                    }),
                    params: toURLSearchParams(serializedData),
                },
            ],
        };
        return metadata;
    }
    __listRoles.fromReq = fromReq;
    __listRoles.__isAmbassador = true;
    return __listRoles;
}
/** Lists all member roles, filtered by nickname or by id */
export function listMembers(payload) {
    var _a = serializer(_listMembersRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listMembersResponse, {}).fromJSON;
    function __listMembers(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.ListMembers',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/member-roles',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listMembers.fromReq = fromReq;
    __listMembers.__isAmbassador = true;
    return __listMembers;
}
/** Lists permission levels */
export function listPermissionLevels(payload) {
    var _a = serializer(_listPermissionLevelsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_listPermissionLevelsResponse, {}).fromJSON;
    function __listPermissionLevels(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'GET',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.ListPermissionLevels',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/permissions/level',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __listPermissionLevels.fromReq = fromReq;
    __listPermissionLevels.__isAmbassador = true;
    return __listPermissionLevels;
}
/** Member may request permission to view selected folder */
export function requestAccess(payload) {
    var _a = serializer(_requestAccessRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_requestAccessResponse, {}).fromJSON;
    function __requestAccess(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.file_sharing.v1.role',
            method: 'POST',
            methodFqn: 'wix.filesharing.api.v1.permissions.PermissionsService.RequestAccess',
            url: resolveWixFilesharingApiV1PermissionsPermissionsServiceUrl({
                protoPath: '/api/v1/file-sharing/permissions/request',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __requestAccess.fromReq = fromReq;
    __requestAccess.__isAmbassador = true;
    return __requestAccess;
}
//# sourceMappingURL=http.impl.js.map